import {useAsyncState, UseAsyncStateOptions, UseImageOptions} from '@vueuse/core'
import {MaybeRefOrGetter, toValue, watch} from 'vue'

function loadImage(options: UseImageOptions): Promise<HTMLImageElement | undefined> {
  return new Promise((resolve, reject) => {
    const {src, srcset, sizes, class: clazz, loading, crossorigin, referrerPolicy} = options
    if(!src) {
      return resolve(undefined)
    }
    const img = new Image()

    img.src = src

    if (srcset)
      img.srcset = srcset

    if (sizes)
      img.sizes = sizes

    if (clazz)
      img.className = clazz

    if (loading)
      img.loading = loading

    if (crossorigin)
      img.crossOrigin = crossorigin

    if (referrerPolicy)
      img.referrerPolicy = referrerPolicy

    img.onload = () => resolve(img)
    img.onerror = reject
  })
}

export function useImage<Shallow extends true>(options: MaybeRefOrGetter<UseImageOptions>, asyncStateOptions: UseAsyncStateOptions<Shallow> = {}) {
  const state = useAsyncState<HTMLImageElement | undefined>(
    () => loadImage(toValue(options)),
    undefined,
    {
      resetOnExecute: true,
      ...asyncStateOptions,
    },
  )

  watch(
    () => toValue(options),
    () => state.execute(asyncStateOptions.delay).catch(() => null),
    {deep: true},
  )

  return state
}

export type UseImageReturn = ReturnType<typeof useImage>
